"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.aline = void 0;
function aline(text) {
    const lines = [];
    for (const line of text.split("\n")) {
        if (line.trimStart().startsWith("|")) {
            lines.push(line.trimStart().slice(1));
        }
        else {
            lines.push(line);
        }
    }
    return lines.join("\n");
}
exports.aline = aline;
//# sourceMappingURL=aline.js.map